import { useEffect, useState } from "react";
import api from "@/lib/api";
import { currentLanguage } from "@/lib/i18n";
import { Languages } from "lucide-react";

export function useJobTranslation(job) {
  const [lang, setLang] = useState(currentLanguage());
  const [tr, setTr] = useState(null);
  const [showOriginal, setShowOriginal] = useState(false);
  const key = job ? [job.id, job.notes, job.materials, ...(job.items || []).flatMap((i) => [i.name, i.note])].join("|") : "";

  useEffect(() => {
    const on = (e) => setLang(e.detail);
    window.addEventListener("iot-lang-change", on);
    return () => window.removeEventListener("iot-lang-change", on);
  }, []);

  useEffect(() => {
    setTr(null);
    if (!job?.id || lang === "it") return;
    let alive = true;
    api.get(`/jobs/${job.id}/translated`, { params: { lang } }).then((r) => { if (alive) setTr(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, [key, lang]); // eslint-disable-line react-hooks/exhaustive-deps

  const active = tr && !showOriginal;
  return {
    available: !!tr,
    showOriginal,
    toggle: () => setShowOriginal((v) => !v),
    t: (field, original) => (active && tr[field]) || original,
    item: (idx, field, original) => (active && tr.items?.[idx]?.[field]) || original,
  };
}

export function TranslationBar({ tr }) {
  if (!tr.available) return null;
  return (
    <div className="flex items-center gap-3 bg-sky-50 border border-sky-200 text-sky-900 rounded-xl px-4 py-2.5 text-sm" data-testid="job-translation-bar">
      <Languages className="w-4 h-4 shrink-0" />
      <span className="flex-1">{tr.showOriginal ? "Testi originali in italiano" : "Note e oggetti tradotti automaticamente"}</span>
      <button onClick={tr.toggle} className="font-semibold underline underline-offset-2 hover:text-sky-700" data-testid="job-translation-toggle">
        {tr.showOriginal ? "Mostra tradotto" : "Mostra originale"}
      </button>
    </div>
  );
}
